<template>
  <div class="resident-modern">
    <NavBar />
    <AuthBySessionExpired />

    <div class="resident-container">
      <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
        <!-- Header Section -->
        <div class="resident-header">
          <div class="header-content">
            <!-- Back Button -->
            <div class="back-section">
              <v-btn class="btn-return" @click="handleToBack">
                <i class="fas fa-arrow-left mr-2"></i>
                Voltar
              </v-btn>
            </div>

            <!-- Resident Info -->
            <div class="resident-info-section">
              <img
                :src="photo || require('../assets/user.png')"
                :alt="name"
                class="avatar-image"
              />

              <div>
                <h1 class="resident-name">{{ name }}</h1>

                <p v-if="resident.pathology" class="m-0">
                  <strong>Patologia (Doença):</strong>
                  {{ resident.pathology }}
                </p>

                <p v-if="resident.miscellaneous_allergies" class="m-0">
                  <strong>Alergia Diversas:</strong>
                  {{ resident.miscellaneous_allergies }}
                </p>

                <AIVitalSigns :resident_id="resident_id" />

                <FallRiskBadge :resident_id="resident_id" />

                <NutritionRiskBadge :resident_id="resident_id" />

                <ClinicalRiskBadge :resident_id="resident_id" />

                <!-- <div class="mt-1">
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div
                        class="alert-badge alert-primary"
                        @click="handlePendingVerification('check')"
                      >
                        <i class="fas fa-user-md mr-2"></i>
                        <span
                          >Está sendo acompanhado(a) por conta de problemas de
                          saúde</span
                        >
                        <span class="badge-count">1</span>
                      </div>
                    </template>
                  </tippy>
                </div> -->
              </div>
            </div>

            <div class="text-right">
              <!-- Medicamentos Pendentes -->
              <div
                v-if="
                  permission('read', 'resident_daily_routine_medicine_check') &&
                  showChecks
                "
                class="mb-1"
              >
                <div v-if="loadingVerifyChecksPending" class="loading-badge">
                  <b-spinner small />
                  <span>Verificando...</span>
                </div>

                <tippy
                  v-else-if="
                    dates.length > 0 && step != 'VERIFICACAO_DE_PENDENCIAS'
                  "
                  arrow
                  theme="light"
                  trigger="click"
                  interactive
                  placement="bottom"
                >
                  <template v-slot:trigger>
                    <div
                      class="alert-badge alert-critical"
                      @click="handlePendingVerification('check')"
                    >
                      <i class="fas fa-capsules mr-2"></i>
                      <span>Medicamentos Pendentes</span>
                      <span class="badge-count">{{ dates.length }}</span>
                    </div>
                  </template>
                  <div class="tooltip-content">
                    <h6 class="tooltip-title">Medicamentos Pendentes</h6>
                    <p class="tooltip-text">
                      {{ dates.length }} medicamento(s) pendente(s)
                    </p>
                    <v-btn
                      @click="handlePendingVerification('check')"
                      class="tooltip-action"
                      small
                    >
                      Acessar
                    </v-btn>
                  </div>
                </tippy>
              </div>

              <!-- Semiologia Pendente -->
              <div
                v-if="permission('read', 'semiology') && showsemiologies"
                class="mb-1"
              >
                <div
                  v-if="loadingVerifysemiologiesPending"
                  class="loading-badge"
                >
                  <b-spinner small />
                  <span>Verificando...</span>
                </div>

                <tippy
                  v-else-if="
                    totalSemiologies > 0 && step != 'VERIFICACAO_DE_PENDENCIAS'
                  "
                  arrow
                  theme="light"
                  trigger="click"
                  interactive
                  placement="bottom"
                >
                  <template v-slot:trigger>
                    <div
                      class="alert-badge alert-warning"
                      @click="handlePendingVerification('semiology')"
                    >
                      <i class="fas fa-edit mr-2"></i>
                      <span>Semiologia Pendentes</span>
                      <span class="badge-count">{{ totalSemiologies }}</span>
                    </div>
                  </template>
                  <div class="tooltip-content">
                    <h6 class="tooltip-title">Formulários Pendentes</h6>
                    <p class="tooltip-text">
                      {{ totalSemiologies }} formulário(s) pendente(s)
                    </p>
                    <v-btn
                      @click="handlePendingVerification('semiology')"
                      class="tooltip-action"
                      small
                    >
                      Acessar
                    </v-btn>
                  </div>
                </tippy>
              </div>
            </div>

            <!-- Mobile Menu Button -->
            <div class="mobile-menu" v-if="width <= 959">
              <div class="dropdown">
                <button
                  class="mobile-menu-btn"
                  id="dropdownMenu2"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i class="fas fa-bars"></i>
                </button>

                <div
                  class="dropdown-menu modern-dropdown"
                  aria-labelledby="dropdownMenu2"
                >
                  <!-- DADOS CADASTRAIS -->
                  <button
                    v-if="
                      $store.state.online &&
                      permission('read', 'resident_information')
                    "
                    @click="handleStep('INFORMACOES')"
                    :outlined="step != 'INFORMACOES'"
                    :class="['sidebar-item', { active: step == 'INFORMACOES' }]"
                  >
                    DADOS CADASTRAIS
                  </button>

                  <!-- CONTRATO -->
                  <button
                    v-if="$store.state.online && permission('read', 'contract')"
                    @click="handleStep('CONTRATO')"
                    :outlined="step != 'CONTRATO'"
                    :class="[
                      'sidebar-item highlighted-as-forward',
                      { active: step == 'CONTRATO' },
                    ]"
                  >
                    CONTRATO
                  </button>

                  <!-- AGENDA -->
                  <button
                    v-if="$store.state.online && permission('read', 'schedule')"
                    @click="handleStep('AGENDA')"
                    :outlined="step != 'AGENDA'"
                    :class="['sidebar-item', { active: step == 'AGENDA' }]"
                  >
                    AGENDA
                  </button>

                  <!-- PASTA -->
                  <button
                    v-if="$store.state.online && permission('read', 'folder')"
                    @click="handleStep('PASTA')"
                    :outlined="step != 'PASTA'"
                    :class="[
                      'sidebar-item highlighted-as-forward',
                      { active: step == 'PASTA' },
                    ]"
                  >
                    PASTA
                  </button>

                  <!-- ENFERMEIRO(A) -->
                  <button
                    v-if="
                      (permission('read', 'resident_nurse_schedule') ||
                        permission('read', 'evolution_nursing')) &&
                      $store.state.online
                    "
                    @click="handleStep('ENFERMEIRO')"
                    :outlined="step != 'ENFERMEIRO'"
                    :class="['sidebar-item', { active: step == 'ENFERMEIRO' }]"
                  >
                    ENFERMEIRO(A)
                  </button>

                  <!-- MÉDICO -->
                  <button
                    v-if="
                      (permission('read', 'resident_medical_prescription') ||
                        permission('read', 'doctor_recipe') ||
                        permission('read', 'evolution_doctor')) &&
                      $store.state.online
                    "
                    @click="handleStep('MEDICO')"
                    :outlined="step != 'MEDICO'"
                    :class="['sidebar-item', { active: step == 'MEDICO' }]"
                  >
                    MÉDICO
                  </button>

                  <!-- RESPONSÁVEL TÉCNICO -->
                  <button
                    v-if="
                      permission('read', 'evolution_technical_manager') &&
                      $store.state.online
                    "
                    @click="handleStep('RESPONSAVEL_TECNICO')"
                    :outlined="step != 'RESPONSAVEL_TECNICO'"
                    :class="[
                      'sidebar-item',
                      { active: step == 'RESPONSAVEL_TECNICO' },
                    ]"
                  >
                    RESPONSÁVEL TÉCNICO
                  </button>

                  <!-- evolution_caregiver -->
                  <button
                    v-if="
                      permission('read', 'evolution_caregiver') &&
                      $store.state.online
                    "
                    @click="handleStep('CUIDADOR')"
                    :outlined="step != 'CUIDADOR'"
                    :class="['sidebar-item', { active: step == 'CUIDADOR' }]"
                  >
                    COORDENADOR (A) DE CUIDADOS
                  </button>

                  <!-- CUIDADOS -->
                  <button
                    v-if="
                      permission('read', 'resident_care_prescription') &&
                      $store.state.online
                    "
                    @click="handleStep('CUIDADOS')"
                    :outlined="step != 'CUIDADOS'"
                    :class="['sidebar-item', { active: step == 'CUIDADOS' }]"
                  >
                    CUIDADOS
                  </button>

                  <!-- IMC -->
                  <button
                    v-if="
                      (permission('read', 'resident_vital_signs') ||
                        permission('read', 'resident_annotation')) &&
                      $store.state.online
                    "
                    @click="handleStep('IMC')"
                    :outlined="step != 'IMC'"
                    :class="['sidebar-item', { active: step == 'IMC' }]"
                  >
                    IMC <small>(Peso/Altura)</small>
                  </button>

                  <!-- ROTINA DIÁRIA -->
                  <button
                    v-if="
                      permission('read', 'resident_vital_signs') ||
                      permission('read', 'resident_annotation') ||
                      permission(
                        'read',
                        'resident_daily_routine_medicine_check'
                      ) ||
                      permission('read', 'resident_daily_routine_care_check') ||
                      permission(
                        'read',
                        'resident_daily_routine_check_prescription'
                      ) ||
                      permission(
                        'read',
                        'resident_daily_routine_check_prescription_care'
                      )
                    "
                    @click="handleStep('ROTINA_DIARIA')"
                    :outlined="step != 'ROTINA_DIARIA'"
                    :class="[
                      'sidebar-item',
                      { active: step == 'ROTINA_DIARIA' },
                    ]"
                  >
                    ROTINA DIÁRIA
                  </button>

                  <!-- SAÚDE -->
                  <button
                    v-if="permission('read', 'resident_health')"
                    @click="handleStep('SAUDE')"
                    :outlined="step != 'SAUDE'"
                    :class="['sidebar-item', { active: step == 'SAUDE' }]"
                  >
                    SAÚDE
                  </button>

                  <!-- CONTA CORRENTE DO RESIDENTE -->
                  <button
                    v-if="
                      permission(
                        'read',
                        'current_account_and_financial_integration'
                      ) && $store.state.online
                    "
                    @click="handleStep('CONTA_CORRENTE')"
                    :outlined="step != 'CONTA_CORRENTE'"
                    :class="[
                      'sidebar-item highlighted-as-forward',
                      { active: step == 'CONTA_CORRENTE' },
                    ]"
                  >
                    CONTA CORRENTE DO RESIDENTE
                  </button>

                  <!-- Luiz verificar permissão -->
                  <!-- WHATSAPP DO RESIDENTE -->
                  <button
                    v-if="
                      permission('read', 'whatsapp_report_medicine') &&
                      $store.state.online
                    "
                    @click="handleStep('WHATSAPP')"
                    :outlined="step != 'WHATSAPP'"
                    :class="[
                      'sidebar-item highlighted-as-forward',
                      { active: step == 'WHATSAPP' },
                    ]"
                  >
                    WHATSAPP
                  </button>

                  <!-- EQUIPE MULTIDISCIPLINAR -->
                  <div
                    class="sidebar-dropdown"
                    v-if="
                      $store.state.online &&
                      (permission('read', 'evolution_social_worker') ||
                        permission('read', 'evolution_physical_educator') ||
                        permission(
                          'read',
                          'evolution_educators_and_pedagogues'
                        ) ||
                        permission('read', 'evolution_physiotherapist') ||
                        permission('read', 'evolution_speech_therapist') ||
                        permission('read', 'evolution_music_therapy') ||
                        permission('read', 'evolution_nutritionist') ||
                        permission('read', 'evolution_psychologist') ||
                        permission('read', 'evolution_occupational_therapist'))
                    "
                  >
                    <b-dropdown
                      text="EQUIPE MULTIDISCIPLINAR"
                      class="sidebar-dropdown-btn"
                      variant="link"
                      no-caret
                      block
                    >
                      <template #button-content>
                        <i class="fas fa-users sidebar-icon"></i>
                        <span class="sidebar-text"
                          >EQUIPE MULTIDISCIPLINAR</span
                        >
                        <i class="fas fa-chevron-down dropdown-arrow"></i>
                      </template>

                      <div
                        v-for="evolution_type in evolution_types"
                        :key="evolution_type.id"
                        v-show="
                          !['MEDICO', 'ENFERMEIRO', 'CUIDADOR'].includes(
                            evolution_type.type
                          )
                        "
                      >
                        <b-dropdown-item
                          @click="
                            handleStep(
                              'EVOLUCOES',
                              null,
                              null,
                              evolution_type.type
                            )
                          "
                          :active="step == evolution_type.type"
                          class="sidebar-dropdown-item"
                        >
                          <i class="fas fa-hands-helping mr-2"></i>
                          {{ evolution_type.name }}
                        </b-dropdown-item>
                      </div>
                    </b-dropdown>
                    <div
                      :class="[
                        'dropdown-item',
                        'modern-dropdown-item',
                        'triangulo-para-direita',
                      ]"
                    ></div>
                  </div>
                  <!-- ESTOQUE -->
                  <button
                    v-if="
                      permission('read', 'resident_stock') &&
                      $store.state.online
                    "
                    @click="handleStep('ESTOQUE')"
                    :outlined="step != 'ESTOQUE'"
                    :class="['sidebar-item', { active: step == 'ESTOQUE' }]"
                  >
                    ESTOQUE
                  </button>
                  <!-- ENTREGA_DE_PRODUTOS -->
                  <button
                    v-if="permission('read', 'list') && $store.state.online"
                    @click="handleStep('ENTREGA_DE_PRODUTOS')"
                    :outlined="step != 'ENTREGA_DE_PRODUTOS'"
                    :class="[
                      'sidebar-item',
                      { active: step == 'ENTREGA_DE_PRODUTOS' },
                    ]"
                  >
                    CONTROLE DE PRODUTOS PARA COMPRAR
                  </button>
                  <!-- INTEGRAÇÃO COM FINANCEIRO -->
                  <button
                    v-if="
                      permission('read', 'family') &&
                      permission('read', 'financial') &&
                      $store.state.online
                    "
                    @click="handleStep('FINANCEIRO')"
                    :outlined="step != 'FINANCEIRO'"
                    :class="[
                      'sidebar-item highlighted-as-forward',
                      { active: step == 'FINANCEIRO' },
                    ]"
                  >
                    INTEGRAÇÃO COM FINANCEIRO
                  </button>
                  <button
                    v-if="
                      permission('read', 'family') &&
                      permission('read', 'financial') &&
                      $store.state.online &&
                      false
                    "
                    @click="handleStep('FINANCEIRO', 'hosting')"
                    :class="['sidebar-item']"
                  >
                    LANÇAR HOSPEDAGEM
                  </button>

                  <button
                    v-if="
                      permission('read', 'family') &&
                      permission('read', 'financial') &&
                      $store.state.online
                    "
                    @click="handleStep('FINANCEIRO', 'service')"
                    :class="['sidebar-item highlighted-as-forward']"
                  >
                    LANÇAR SERVIÇO
                  </button>

                  <button
                    v-if="
                      permission('read', 'family') &&
                      permission('read', 'financial') &&
                      $store.state.online
                    "
                    @click="handleStep('FINANCEIRO', 'sale', 'medicine')"
                    :class="['sidebar-item highlighted-as-forward']"
                  >
                    LANÇAR VENDA MEDICAMENTO
                  </button>

                  <button
                    v-if="
                      permission('read', 'family') &&
                      permission('read', 'financial') &&
                      $store.state.online
                    "
                    @click="handleStep('FINANCEIRO', 'sale', 'product')"
                    :class="['sidebar-item highlighted-as-forward']"
                  >
                    LANÇAR VENDA PRODUTO
                  </button>
                  <!-- PEDIDOS DIVERSOS -->
                  <button
                    v-if="
                      permission('read', 'resident_has_order') &&
                      $store.state.online
                    "
                    @click="handleStep('PEDIDOS')"
                    :outlined="step != 'PEDIDOS'"
                    :class="['sidebar-item', { active: step == 'PEDIDOS' }]"
                  >
                    PEDIDOS DIVERSOS
                  </button>
                  <!-- SEMIOLOGIA -->
                  <button
                    v-if="
                      permission('read', 'semiology') && $store.state.online
                    "
                    @click="handleStep('SEMIOLOGIA')"
                    :outlined="step != 'SEMIOLOGIA'"
                    :class="['sidebar-item', { active: step == 'SEMIOLOGIA' }]"
                  >
                    SEMIOLOGIA
                  </button>
                  <!-- VERIFICAÇÃO DE PENDÊNCIAS -->
                  <button
                    v-if="
                      permission('read', 'resident_pending_verification') &&
                      $store.state.online
                    "
                    @click="handleStep('VERIFICACAO_DE_PENDENCIAS')"
                    :outlined="step != 'VERIFICACAO_DE_PENDENCIAS'"
                    :class="[
                      'sidebar-item',
                      { active: step == 'VERIFICACAO_DE_PENDENCIAS' },
                    ]"
                  >
                    VERIFICAÇÃO DE PENDÊNCIAS
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="v-content-card text-right">
          <v-btn class="btn-health-problem">
            <i class="fas fa-user-md mr-2"></i>
            Está sendo acompanhado(a) por conta de problemas de saúde
          </v-btn>
        </div> -->

        <!-- Main Content Layout -->
        <div class="main-layout">
          <!-- Sidebar Navigation (Desktop) -->
          <div class="sidebar-navigation" v-if="width > 959">
            <div class="sidebar-container">
              <!-- Dados Cadastrais -->
              <button
                v-if="
                  $store.state.online &&
                  permission('read', 'resident_information')
                "
                @click="handleStep('INFORMACOES')"
                :class="['sidebar-item', { active: step == 'INFORMACOES' }]"
              >
                <i class="fas fa-user sidebar-icon"></i>
                <span class="sidebar-text">DADOS CADASTRAIS</span>
              </button>

              <!-- CONTRATO  -->
              <button
                v-if="$store.state.online && permission('read', 'contract')"
                @click="handleStep('CONTRATO')"
                :class="[
                  'sidebar-item highlighted-as-forward',
                  { active: step == 'CONTRATO' },
                ]"
              >
                <i class="fas fa-file-contract sidebar-icon"></i>
                <span class="sidebar-text">CONTRATOS</span>
              </button>

              <!-- AGENDA -->
              <button
                v-if="$store.state.online && permission('read', 'schedule')"
                @click="handleStep('AGENDA')"
                :class="['sidebar-item', { active: step == 'AGENDA' }]"
              >
                <i class="fas fa-calendar sidebar-icon"></i>
                <span class="sidebar-text">AGENDA</span>
              </button>

              <!-- PASTA -->
              <button
                v-if="$store.state.online && permission('read', 'folder')"
                @click="handleStep('PASTA')"
                :class="[
                  'sidebar-item highlighted-as-forward',
                  { active: step == 'PASTA' },
                ]"
              >
                <i class="fas fa-folder sidebar-icon"></i>
                <span class="sidebar-text">PASTA</span>
              </button>

              <!-- Enfermeiro -->
              <button
                v-if="
                  (permission('read', 'resident_nurse_schedule') ||
                    permission('read', 'evolution_nursing')) &&
                  $store.state.online
                "
                @click="handleStep('ENFERMEIRO')"
                :class="['sidebar-item', { active: step == 'ENFERMEIRO' }]"
              >
                <i class="fas fa-user-nurse sidebar-icon"></i>
                <span class="sidebar-text">ENFERMEIRO(A)</span>
              </button>

              <!-- Médico -->
              <button
                v-if="
                  (permission('read', 'resident_medical_prescription') ||
                    permission('read', 'doctor_recipe') ||
                    permission('read', 'evolution_doctor')) &&
                  $store.state.online
                "
                @click="handleStep('MEDICO')"
                :class="['sidebar-item', { active: step == 'MEDICO' }]"
              >
                <i class="fas fa-user-md sidebar-icon"></i>
                <span class="sidebar-text">MÉDICO</span>
              </button>

              <!-- Respnsável técnico -->
              <button
                v-if="
                  permission('read', 'evolution_technical_manager') &&
                  $store.state.online
                "
                @click="handleStep('RESPONSAVEL_TECNICO')"
                :class="[
                  'sidebar-item',
                  { active: step == 'RESPONSAVEL_TECNICO' },
                ]"
              >
                <i class="fas fa-user sidebar-icon"></i>
                <span class="sidebar-text">RESPONSÁVEL TÉCNICO</span>
              </button>

              <!-- Cordenador (a) cuidados -->
              <button
                v-if="
                  permission('read', 'evolution_caregiver') &&
                  $store.state.online
                "
                @click="handleStep('CUIDADOR')"
                :class="['sidebar-item', { active: step == 'CUIDADOR' }]"
              >
                <i class="fas fa-user sidebar-icon"></i>
                <span class="sidebar-text">COORDENADOR (A) DE CUIDADOS</span>
              </button>

              <!-- Cuidados -->
              <button
                v-if="
                  permission('read', 'resident_care_prescription') &&
                  $store.state.online
                "
                @click="handleStep('CUIDADOS')"
                :class="['sidebar-item', { active: step == 'CUIDADOS' }]"
              >
                <i class="fas fa-hands-helping sidebar-icon"></i>
                <span class="sidebar-text">CUIDADOS</span>
              </button>

              <!-- IMC -->
              <button
                v-if="
                  (permission('read', 'resident_vital_signs') ||
                    permission('read', 'resident_annotation')) &&
                  $store.state.online
                "
                @click="handleStep('IMC')"
                :class="['sidebar-item', { active: step == 'IMC' }]"
              >
                <i class="fas fa-pencil-ruler sidebar-icon"></i>
                <span class="sidebar-text"
                  >IMC <small>(Peso/Altura)</small></span
                >
              </button>

              <!-- Rotina Diária -->
              <button
                v-if="
                  permission('read', 'resident_vital_signs') ||
                  permission('read', 'resident_annotation') ||
                  permission('read', 'resident_daily_routine_medicine_check') ||
                  permission('read', 'resident_daily_routine_care_check') ||
                  permission(
                    'read',
                    'resident_daily_routine_check_prescription'
                  ) ||
                  permission(
                    'read',
                    'resident_daily_routine_check_prescription_care'
                  )
                "
                @click="handleStep('ROTINA_DIARIA')"
                :class="['sidebar-item', { active: step == 'ROTINA_DIARIA' }]"
              >
                <i class="fas fa-calendar-day sidebar-icon"></i>
                <span class="sidebar-text">ROTINA DIÁRIA</span>
              </button>

              <!-- Saúde -->
              <button
                v-if="permission('read', 'resident_health')"
                @click="handleStep('SAUDE')"
                :class="['sidebar-item', { active: step == 'SAUDE' }]"
              >
                <i class="fas fa-heartbeat sidebar-icon"></i>
                <span class="sidebar-text">SAÚDE</span>
              </button>

              <!-- Conta Corrente -->
              <button
                v-if="
                  permission(
                    'read',
                    'current_account_and_financial_integration'
                  ) && $store.state.online
                "
                @click="handleStep('CONTA_CORRENTE')"
                :class="[
                  'sidebar-item highlighted-as-forward',
                  { active: step == 'CONTA_CORRENTE' },
                ]"
              >
                <i class="fas fa-credit-card sidebar-icon"></i>
                <span class="sidebar-text">CONTA CORRENTE DO RESIDENTE</span>
              </button>

              <!-- Luiz verificar permissão -->
              <!-- WhatsApp -->
              <button
                v-if="
                  permission('read', 'whatsapp_report_medicine') &&
                  $store.state.online
                "
                @click="handleStep('WHATSAPP')"
                :class="[
                  'sidebar-item highlighted-as-forward',
                  { active: step == 'WHATSAPP' },
                ]"
              >
                <i class="fas fa-mobile-alt sidebar-icon"></i>
                <span class="sidebar-text">WHATSAPP</span>
              </button>

              <!-- Equipe Multidisciplinar -->
              <div
                v-if="
                  $store.state.online &&
                  (permission('read', 'evolution_social_worker') ||
                    permission('read', 'evolution_physical_educator') ||
                    permission('read', 'evolution_educators_and_pedagogues') ||
                    permission('read', 'evolution_physiotherapist') ||
                    permission('read', 'evolution_speech_therapist') ||
                    permission('read', 'evolution_music_therapy') ||
                    permission('read', 'evolution_nutritionist') ||
                    permission('read', 'evolution_psychologist') ||
                    permission('read', 'evolution_occupational_therapist'))
                "
                class="sidebar-dropdown"
              >
                <b-dropdown
                  class="sidebar-dropdown-btn"
                  variant="link"
                  no-caret
                  block
                >
                  <template #button-content>
                    <i class="fas fa-users sidebar-icon"></i>
                    <span class="sidebar-text">EQUIPE MULTIDISCIPLINAR</span>
                    <i class="fas fa-chevron-down dropdown-arrow"></i>
                  </template>

                  <div
                    v-for="evolution_type in evolution_types"
                    :key="evolution_type.id"
                    v-show="
                      !['MEDICO', 'ENFERMEIRO', 'CUIDADOR'].includes(
                        evolution_type.type
                      )
                    "
                  >
                    <b-dropdown-item
                      @click="
                        handleStep('EVOLUCOES', null, null, evolution_type.type)
                      "
                      :active="step == evolution_type.type"
                      class="sidebar-dropdown-item"
                    >
                      <i class="fas fa-hands-helping mr-2"></i>
                      {{ evolution_type.name }}
                    </b-dropdown-item>
                  </div>
                </b-dropdown>
              </div>

              <!-- Estoque -->
              <button
                v-if="
                  permission('read', 'resident_stock') && $store.state.online
                "
                @click="handleStep('ESTOQUE')"
                :class="['sidebar-item', { active: step == 'ESTOQUE' }]"
              >
                <i class="fas fa-box sidebar-icon"></i>
                <span class="sidebar-text">ESTOQUE</span>
              </button>

              <!-- Controle de Produtos -->
              <button
                v-if="permission('read', 'list') && $store.state.online"
                @click="handleStep('ENTREGA_DE_PRODUTOS')"
                :class="[
                  'sidebar-item',
                  { active: step == 'ENTREGA_DE_PRODUTOS' },
                ]"
              >
                <i class="fas fa-truck sidebar-icon"></i>
                <span class="sidebar-text"
                  >CONTROLE DE PRODUTOS PARA COMPRAR</span
                >
              </button>

              <!-- Integração com Financeiro -->
              <button
                v-if="
                  permission('read', 'family') &&
                  permission('read', 'financial') &&
                  $store.state.online
                "
                @click="handleStep('FINANCEIRO')"
                :class="[
                  'sidebar-item highlighted-as-forward',
                  { active: step == 'FINANCEIRO' },
                ]"
              >
                <i class="fas fa-dollar-sign sidebar-icon"></i>
                <span class="sidebar-text">INTEGRAÇÃO COM FINANCEIRO</span>
              </button>

              <button
                v-if="
                  permission('read', 'family') &&
                  permission('read', 'financial') &&
                  $store.state.online &&
                  false
                "
                @click="handleStep('FINANCEIRO', 'hosting')"
                :class="['sidebar-item']"
              >
                <i class="fas fa-plus sidebar-icon"></i>
                <span class="sidebar-text">LANÇAR HOSPEDAGEM</span>
              </button>

              <button
                v-if="
                  permission('read', 'family') &&
                  permission('read', 'financial') &&
                  $store.state.online
                "
                @click="handleStep('FINANCEIRO', 'service')"
                :class="['sidebar-item highlighted-as-forward']"
              >
                <i class="fas fa-plus sidebar-icon"></i>
                <span class="sidebar-text">LANÇAR SERVIÇO</span>
              </button>

              <button
                v-if="
                  permission('read', 'family') &&
                  permission('read', 'financial') &&
                  $store.state.online
                "
                @click="handleStep('FINANCEIRO', 'sale', 'medicine')"
                :class="['sidebar-item highlighted-as-forward']"
              >
                <i class="fas fa-plus sidebar-icon"></i>
                <span class="sidebar-text">LANÇAR VENDA MEDICAMENTO</span>
              </button>

              <button
                v-if="
                  permission('read', 'family') &&
                  permission('read', 'financial') &&
                  $store.state.online
                "
                @click="handleStep('FINANCEIRO', 'sale', 'product')"
                :class="['sidebar-item highlighted-as-forward']"
              >
                <i class="fas fa-plus sidebar-icon"></i>
                <span class="sidebar-text">LANÇAR VENDA PRODUTO</span>
              </button>

              <!-- Pedidos Diversos -->
              <button
                v-if="
                  permission('read', 'resident_has_order') &&
                  $store.state.online
                "
                @click="handleStep('PEDIDOS')"
                :class="['sidebar-item', { active: step == 'PEDIDOS' }]"
              >
                <i class="fas fa-shopping-cart sidebar-icon"></i>
                <span class="sidebar-text">PEDIDOS DIVERSOS</span>
              </button>

              <!-- Semiologia -->
              <button
                v-if="permission('read', 'semiology') && $store.state.online"
                @click="handleStep('SEMIOLOGIA')"
                :class="['sidebar-item', { active: step == 'SEMIOLOGIA' }]"
              >
                <i class="fas fa-clipboard-list sidebar-icon"></i>
                <span class="sidebar-text">SEMIOLOGIA</span>
              </button>

              <!-- Verificação de Pendências -->
              <button
                v-if="
                  permission('read', 'resident_pending_verification') &&
                  $store.state.online
                "
                @click="handleStep('VERIFICACAO_DE_PENDENCIAS')"
                :class="[
                  'sidebar-item',
                  { active: step == 'VERIFICACAO_DE_PENDENCIAS' },
                ]"
              >
                <i class="fas fa-exclamation-triangle sidebar-icon"></i>
                <span class="sidebar-text">VERIFICAÇÃO DE PENDÊNCIAS</span>
              </button>
            </div>
          </div>

          <!-- Content Section -->
          <div class="content-section">
            <RegistrationData
              @handleStep="handleStep($event)"
              @getDatesChecksPending="getDatesChecksPending"
              @getSemiologiesPending="getSemiologiesPending"
              @pendingVerification="pendingVerification"
              @handleToResident="handleToResident"
              @configbox="retrieve"
              @getresident="get"
              :resident="resident"
              :step="step"
              :width="width"
              :type_of_food="type_of_food"
            />
            <errors-messages :errors="errors" />
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ErrorsMessages from "../templates/Components/ErrorsMessages.vue";
import RegistrationData from "../templates/Resident/RegistrationData";
import AIVitalSigns from "../templates/AI/VitalSigns";
import FallRiskBadge from "../templates/AI/FallRiskBadge";
import NutritionRiskBadge from "../templates/AI/NutritionRiskBadge";
import ClinicalRiskBadge from "../templates/AI/ClinicalRiskBadge";
import api from "../services/api";
import routes from "../routes";
import { getStatic } from "../lib/functions";
import { formatDate, formatDateToUs } from "../lib/format";
import permission from "../lib/permission";

export default {
  name: "Resident",
  components: {
    NavBar,
    AuthBySessionExpired,
    RegistrationData,
    ErrorsMessages,
    AIVitalSigns,
    FallRiskBadge,
    NutritionRiskBadge,
    ClinicalRiskBadge,
  },
  data() {
    return {
      accessed_offline: false,
      step: "SAUDE",
      resident_id: null,
      resident: {},
      name: "",
      evolution_types: [],
      dates: [],
      totalSemiologies: [],
      photo: null,
      type_of_food: "",
      isActiveSideBar: false,
      loadingVerifysemiologiesPending: false,
      loadingVerifyChecksPending: false,
      loading: true,
      showChecks: true,
      showsemiologies: true,
      width: window.screen.width,
      errors: [],
    };
  },
  created() {
    this.retrieve();
    window.addEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },
  methods: {
    permission,
    formatDate,
    formatDateToUs,
    handleToResident(resident_id) {
      if (resident_id) {
        const { id } = routes.history.current.params;
        if (resident_id != id) {
          routes.replace({
            params: { id: resident_id },
            query: { tab: "stock", nav: "devolution" },
          });
          this.retrieve();
        }
      }
    },
    handleStep(step, goToNav = null, saleType = null, evolution_type = null) {
      let newTab = {
        INFORMACOES: "informations",
        AGENDA: "schedules",
        CONTRATO: "contracts",
        PASTA: "folders",
        ROTINA_DIARIA: "check",
        SAUDE: "cheers",
        CUIDADOS: "care",
        IMC: "imc",
        MEDICO: "doctor",
        RESPONSAVEL_TECNICO: "evolution_technical_manager",
        CUIDADOR: "evolution_caregiver",
        ENFERMEIRO: "nurse",
        ESTOQUE: "stock",
        ENTREGA_DE_PRODUTOS: "list",
        SEMIOLOGIA: "semiology",
        NUTRICIONISTA: "nutritionist",
        FISIOTERAPEUTA: "physiotherapist",
        PSICOLOGO: "psychologist",
        FONOAUDIOLOGO: "speech_therapist",
        ASSISTENTE_SOCIAL: "social_worker",
        EDUCADOR_FISICO: "physical_educator",
        EDUCADORES_E_PEDAGOGOS: "educators_and_pedagogues",
        PEDIDOS: "order",
        SERVICO: "service",
        HOSPEDAGEM_FINANCEIRO: "hosting_financial",
        FINANCEIRO: "financial",
        CONTA_CORRENTE: "account",
        WHATSAPP: "whatsapp",
        VERIFICACAO_DE_PENDENCIAS: "pending_verification",
        EVOLUCOES: "evolutions",
      }[step];

      let { tab, nav, sale } = routes.history.current.query;
      if (tab != newTab) {
        if (goToNav) {
          routes.replace({
            query: {
              tab: newTab,
              nav: goToNav,
              sale: saleType,
              create: true,
              action: "create",
            },
          });
        } else {
          if (evolution_type) {
            routes
              .replace({
                query: { tab: newTab + "&evolution_type=" + evolution_type },
              })
              .catch(() => {});
          } else {
            routes.replace({ query: { tab: newTab } });
          }
        }
      } else {
        if (goToNav != nav) {
          routes.replace({
            query: {
              tab: newTab,
              nav: goToNav,
              sale: saleType,
              create: true,
              action: "create",
            },
          });
        } else {
          if (saleType != sale) {
            routes.replace({
              query: {
                tab: newTab,
                nav: goToNav,
                sale: saleType,
                create: true,
                action: "create",
              },
            });
          }
        }
      }

      this.step = step;
    },
    handleOnResize() {
      this.width = window.innerWidth;
    },
    async retrieve() {
      const { id } = routes.history.current.params;
      const { tab } = routes.history.current.query;

      if (tab) {
        if (!permission("read", "resident_daily_routine_medicine_check")) {
          this.step = "INFORMACOES";
        } else {
          this.step = {
            informations: "INFORMACOES",
            schedules: "AGENDA",
            contracts: "CONTRATO",
            folders: "PASTA",
            check: "ROTINA_DIARIA",
            cheers: "SAUDE",
            care: "CUIDADOS",
            imc: "IMC",
            doctor: "MEDICO",
            evolution_technical_manager: "RESPONSAVEL_TECNICO",
            evolution_caregiver: "CUIDADOR",
            nurse: "ENFERMEIRO",
            stock: "ESTOQUE",
            list: "ENTREGA_DE_PRODUTOS",
            semiology: "SEMIOLOGIA",
            nutritionist: "NUTRICIONISTA",
            physiotherapist: "FISIOTERAPEUTA",
            psychologist: "PSICOLOGO",
            speech_therapist: "FONOAUDIOLOGO",
            social_worker: "ASSISTENTE_SOCIAL",
            physical_educator: "EDUCADOR_FISICO",
            educators_and_pedagogues: "EDUCADORES_E_PEDAGOGOS",
            order: "PEDIDOS",
            pending_verification: "VERIFICACAO_DE_PENDENCIAS",
            service: "SERVICO",
            hosting_financial: "HOSPEDAGEM_FINANCEIRO",
            financial: "FINANCEIRO",
            account: "CONTA_CORRENTE",
            whatsapp: "WHATSAPP",
          }[tab];
        }
      }

      this.resident_id = id;
      let accessed_offline = JSON.parse(
        sessionStorage.getItem("accessed_offline") || !this.$store.state.online
      );
      this.accessed_offline = accessed_offline;

      if (accessed_offline) {
        this.loading = false;
        let residents;
        try {
          residents = (await getStatic("/offline/residents", true)).residents;
        } catch (errors) {
          this.errors = errors;
          return;
        }
        let resident = residents.find((item) => item.id == id);
        if (resident) this.name = resident.name;
      } else {
        if (this.errors.length == 0) await this.get();
        if (this.errors.length == 0) await this.getDatesChecksPending();
        if (this.errors.length == 0) await this.getSemiologiesPending();
        if (this.errors.length == 0) await this.getViewersEvolutionsActive();
      }
    },

    async get() {
      try {
        this.loading = true;
        const { resident_id: id } = this;
        let params = { id };
        const response = await api.get("/rest-home/resident/name", { params });
        const { resident, error } = response.data;

        if (error) {
          return routes.push({ name: "dashboard" });
        }
        if (!resident) {
          return routes.push({ name: "dashboard" });
        }

        this.resident = resident;
        this.name = resident.name;
        this.photo = resident.photo_url;
        this.type_of_food = resident.type_of_food;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getDatesChecksPending() {
      try {
        this.loadingVerifyChecksPending = true;
        const { resident_id } = this;
        let params = { resident_id };
        const response = await api.get("/rest-home/resident/checks-pending", {
          params,
        });
        const { error, errors, dates } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.dates = dates;
        }
        this.loadingVerifyChecksPending = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getSemiologiesPending() {
      try {
        this.loadingVerifysemiologiesPending = true;
        const { resident_id } = this;
        let params = { resident_id };
        const response = await api.get(
          "/rest-home/resident/semiologies-pending",
          { params }
        );
        const { error, errors, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.totalSemiologies = total;
        }
        this.loadingVerifysemiologiesPending = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getViewersEvolutionsActive() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/evolutions/settings/actives"
        );

        const { evolution_types } = response.data;

        this.evolution_types = evolution_types;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    checkActiveViewersEvolutions(type) {
      const evolution = this.evolution_types.find((e) => e.type == type);

      return evolution && evolution.active == 1;
    },
    pendingVerification(item) {
      let { tab, nav, date } = item;
      setTimeout(() => {
        routes.replace({ query: { tab, nav, date } });
        if (tab == "semiology") {
          this.step = "SEMIOLOGIA";
        } else {
          this.step = "ROTINA_DIARIA";
        }
      }, 10);
    },
    handleToBack() {
      if (!routes.go(-1)) {
        routes.push({ name: "dashboard" });
      } else {
        routes.go(-1);
      }
    },
    handlePendingVerification(type) {
      if (type == "check") {
        setTimeout(() => {
          routes.replace({
            query: { tab: "pending_verification", nav: "check" },
          });
          this.step = "VERIFICACAO_DE_PENDENCIAS";
        }, 10);
      }
      if (type == "semiology") {
        setTimeout(() => {
          routes.replace({
            query: { tab: "pending_verification", nav: "semiology" },
          });
          this.step = "VERIFICACAO_DE_PENDENCIAS";
        }, 10);
      }
    },
  },
};
</script>

<style scoped>
.resident-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.resident-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.loading-overlay {
  border-radius: 20px;
}

/* Header Section */
.resident-header {
  background: white;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  margin-bottom: 5px;
  overflow: hidden;
}

.header-content {
  padding: 24px;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 24px;
}

/* Resident Info */
.resident-info-section {
  display: flex;
  align-items: center;
  gap: 8px;
}

.avatar-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #0f65b0;
  box-shadow: 0 8px 32px rgba(15, 101, 176, 0.2);
}

.resident-name {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.resident-badges {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.loading-badge {
  display: flex;
  align-items: center;
  padding: 2px 10px;
  background: #f1f5f9;
  border-radius: 20px;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
}

.btn-health-problem {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 20px !important;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
  color: #d97706;
  border: 1px solid #f59e0b;
}

.alert-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.alert-critical {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #dc2626;
  border: 1px solid #f87171;
}

.alert-warning {
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
  color: #d97706;
  border: 1px solid #f59e0b;
}

.alert-primary {
  background: linear-gradient(135deg, #cce5ff 0%, #b2d5fa 100%);
  color: #1f5fa3;
  border: 1px solid #96c1f0;
}

.alert-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.badge-count {
  background: rgba(255, 255, 255, 0.9);
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  margin-left: 4px;
}

/* Tooltip */
.tooltip-content {
  text-align: center;
  padding: 16px;
}

.tooltip-title {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 8px;
}

.tooltip-text {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 12px;
}

.tooltip-action {
  background: #0f65b0 !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
}

/* Mobile Menu */
.mobile-menu-btn {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  width: 48px !important;
  height: 48px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3) !important;
  transition: all 0.3s ease !important;
}

.mobile-menu-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(15, 101, 176, 0.4) !important;
}

.modern-dropdown {
  border: none !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;
  max-height: 1200px !important;
  overflow-y: auto !important;
  position: relative !important;
}

.modern-dropdown-item {
  padding: 12px 20px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #374151 !important;
  border: none !important;
  transition: all 0.3s ease !important;
}

.modern-dropdown-item:hover {
  background: #f8fafc !important;
  color: #0f65b0 !important;
}

.modern-dropdown-item.active {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
}

/* Main Layout */
.main-layout {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 24px;
  align-items: start;
}

/* Sidebar Navigation */
.sidebar-navigation {
  position: sticky;
  top: 24px;
}

.sidebar-container {
  background: white;
  border-radius: 20px;
  padding: 24px 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.sidebar-item {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 16px 24px;
  background: transparent;
  border: none;
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-align: left;
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
  cursor: pointer;
}

.sidebar-item:hover {
  background: #f8fafc;
  color: #0f65b0;
  border-left-color: #e0e7ff;
}

.sidebar-item.active {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
  border-left-color: #0f65b0;
  font-weight: 700;
}

.sidebar-icon {
  width: 20px;
  font-size: 16px;
  color: inherit;
}

.sidebar-text {
  flex: 1;
  color: inherit;
  line-height: 1.3;
}

/* Sidebar Dropdown */
.sidebar-dropdown {
  width: 100%;
}

.sidebar-dropdown-btn {
  width: 100% !important;
  text-align: left !important;
  padding: 16px 24px !important;
  border: none !important;
  border-left: 4px solid transparent !important;
  background: transparent !important;
  color: #64748b !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  transition: all 0.3s ease !important;
}

.sidebar-dropdown-btn >>> .btn {
  display: flex !important;
  align-items: center !important;
  gap: 16px !important;
  width: 100% !important;
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
  color: inherit !important;
  font-size: inherit !important;
  font-weight: inherit !important;
  text-transform: inherit !important;
  letter-spacing: inherit !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.sidebar-dropdown-btn:hover {
  background: #f8fafc !important;
  color: #0f65b0 !important;
  border-left-color: #e0e7ff !important;
}

.sidebar-dropdown-btn.active {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
  border-left-color: #0f65b0 !important;
  font-weight: 700 !important;
}

.dropdown-arrow {
  margin-left: auto;
  font-size: 12px;
  transition: transform 0.3s ease;
}

.sidebar-dropdown-item {
  font-size: 12px !important;
  font-weight: 500 !important;
  color: #6b7280 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  border: none !important;
  transition: all 0.3s ease !important;
}

.sidebar-dropdown-item:hover {
  background: #f8fafc !important;
  color: #0f65b0 !important;
}

.sidebar-dropdown-item.active {
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%) !important;
  color: #4338ca !important;
  font-weight: 600 !important;
}

/* Content Section */
.content-section {
  background: white;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  min-height: 600px;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .main-layout {
    grid-template-columns: 250px 1fr;
    gap: 20px;
  }
}

@media (max-width: 959px) {
  .sidebar-item {
    gap: 8px;
    width: 100%;
    padding: 8px 12px;
    font-size: 13px;
    font-weight: 600;
  }

  .sidebar-dropdown-btn {
    padding: 8px 12px !important;
    font-size: 13px !important;
  }

  .modern-dropdown-item {
    padding: 0px 0px !important;
  }

  .main-layout {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .sidebar-navigation {
    display: none;
  }

  .header-content {
    grid-template-columns: 1fr auto;
    gap: 16px;
  }

  .back-section {
    grid-column: 1 / -1;
    order: 1;
  }

  .mobile-menu {
    order: 2;
  }

  .resident-info-section {
    grid-column: 1 / -1;
    order: 3;
    justify-content: center;
    text-align: center;
  }
}

@media (max-width: 768px) {
  .resident-container {
    padding: 0 16px;
  }

  .header-content {
    padding: 20px;
  }

  .resident-name {
    font-size: 20px;
  }

  .avatar-image {
    width: 60px;
    height: 60px;
  }

  .resident-badges {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .header-content {
    padding: 16px;
  }

  .resident-info-section {
    flex-direction: column;
    gap: 12px;
  }

  .resident-name {
    font-size: 18px;
  }

  .avatar-image {
    width: 50px;
    height: 50px;
  }
}

/* Custom scrollbar for dropdown */
.modern-dropdown::-webkit-scrollbar,
.sidebar-container::-webkit-scrollbar {
  width: 6px;
}

.modern-dropdown::-webkit-scrollbar-track,
.sidebar-container::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.modern-dropdown::-webkit-scrollbar-thumb,
.sidebar-container::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.modern-dropdown::-webkit-scrollbar-thumb:hover,
.sidebar-container::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Legacy compatibility */
.resident-data .photo {
  object-fit: contain;
}
</style>